import Introduction from "./components/introduction/Introduction";
import Main from "./components/main/Main";
import Contact from "./components/contact/Contact";

import styles from "./App.module.css";

function App() {
  return (
    <>
      <Introduction />
      <Main />
      <Contact />
    </>
  );
}

export default App;
